
import { QuillStatic } from "../../types"

import { registerSanitizingClipboardModule } from "./module"

export const registerSanitizingClipboard = (Quill: QuillStatic) => {
  registerSanitizingClipboardModule(Quill)
}
